/* eslint-disable */
/* GENERATED BY DECAFFEINATE */

let $ = jQuery;

//###############################
/* SIMPLECROP PHOTO CROPPER */
//###############################

let simpleCropTemplate = `\
<div class="simplecrop_container">
	<div class="image_frame">
		<div class="image_holder">
		</div>

		<div class="crop_components">
			<div class="crop_area">
				<div class="guides guides_h"></div>
				<div class="guides guides_v"></div>

				<div class="crop_handle handle_n" data-dir="n"><span></span></div>
				<div class="crop_handle handle_e" data-dir="e"><span></span></div>
				<div class="crop_handle handle_s" data-dir="s"><span></span></div>
				<div class="crop_handle handle_w" data-dir="w"><span></span></div>

				<div class="crop_handle handle_nw" data-dir="nw"><span></span></div>
				<div class="crop_handle handle_ne" data-dir="ne"><span></span></div>
				<div class="crop_handle handle_sw" data-dir="sw"><span></span></div>
				<div class="crop_handle handle_se" data-dir="se"><span></span></div>
			</div>
		</div>
</div>\
`;

class SimpleCrop {
	static initClass() {
		// Defaults
		this.prototype.active = false;
		this.prototype.image = {};
		this.prototype.cropData = {};

		// Configurable params
		this.prototype.settings = {
			initialPosition: null,
			aspectRatio: 1,
			cropMin: { width: 0, height: 0 },
			handles: "all",
		};
	}

	constructor(photo, params) {
		this.settings = $.extend({ ...this.settings }, params);
		$.extend(this, params);

		this.element = $(photo);
		this.cropper = $(simpleCropTemplate);
		this.cropArea = this.cropper.find(".crop_area");
		this.imageFrame = this.cropper.find(".image_frame");

		this.element.after(this.cropper);
		this.cropper.find(".image_holder").prepend(this.element);

		$(window).on("resize focus", () => {
			if (this.element && this.active) {
				this.resizeImage();
			}
		});

		if (!this.settings.disabled) {
			this.enable();
		}
	}

	// Enable the cropper
	enable() {
		if (this.active) {
			return;
		}

		this.cropper.addClass("active");
		this.cropper.addClass(`${this.settings.handles}_handles`);

		if (this.settings.initialPosition) {
			this.placeCropArea(this.settings.initialPosition);
		}

		this.resizeImage();
		this.addListeners();

		if (!this.settings.initialPosition) {
			this.resetCropArea();
		}

		this.active = true;
	}

	// Disable the cropper
	disable() {
		if (!this.active) {
			return;
		}

		this.removeListeners();

		// Hold on to the output value since we're hiding stuff, which'll break
		// the crop element's measurements.
		this.savedOutput = this.output();

		// Remove the width constraints on the frame since our listeners are off
		setTimeout(() => {
			this.imageFrame.css("width", "auto");
		}, OkPhotos.animSpeed);

		// Reset image so resizeImage runs like the first time on enable
		this.image = {};

		this.cropper.removeClass("active");
		this.active = false;
	}

	resizeImage() {
		// Reset for proper sizing.
		let oldWidth = this.image.width;
		let oldHeight = this.image.height;
		this.imageFrame.css({
			width: "auto",
			height: "100%",
		});
		this.cropMin = { width: 0, height: 0 };

		// First get natural width / height of image
		this.image.naturalWidth = this.element.get(0).naturalWidth;
		this.image.naturalHeight = this.element.get(0).naturalHeight;
		this.image.width = parseInt(this.element.width(), 10);
		this.image.height = parseInt(this.element.height(), 10);
		this.image.scale = this.image.naturalHeight / this.image.height;

		// If this is a first time run, oldWidth and oldHeight will be null
		if (!oldWidth) {
			oldWidth = this.image.naturalWidth;
			oldHeight = this.image.naturalHeight;
		}

		// Now check out container's constraints
		this.maxSize = {
			width: this.cropper.width(),
			height: this.cropper.height(),
		};

		// If we have a cropMin, adjust it be scale
		this.cropMin.width = Math.floor(
			this.settings.cropMin.width / this.image.scale
		);
		this.cropMin.height = Math.floor(
			this.settings.cropMin.height / this.image.scale
		);

		// Landscape
		if (
			this.image.naturalWidth / this.image.naturalHeight >
			this.maxSize.width / this.maxSize.height
		) {
			this.cropper.removeClass("portrait").addClass("landscape");
			// Portrait
		} else {
			this.cropper.removeClass("landscape").addClass("portrait");
			// Horizontally center by setting width
			this.imageFrame.css("width", this.image.width);
		}

		// Vertically center landscapes / small photos
		if (
			this.cropper.hasClass("landscape") ||
			this.image.naturalHeight < this.maxSize.height
		) {
			let offset = Math.ceil((this.maxSize.height - this.image.height) / 2);
			this.imageFrame.css({
				"margin-top": offset,
				height: `calc(100% - ${offset * 2}px)`,
			});
		}

		// Adjust the cropper position to match the new sizing. Only works if
		// this is triggered when elements are visible.
		if (this.image.width) {
			let widthDiff = this.image.width / oldWidth;
			let heightDiff = this.image.height / oldHeight;

			this.placeCropArea({
				top: this.cropArea.position().top * heightDiff,
				left: this.cropArea.position().left * widthDiff,
				width: this.cropArea.width() * widthDiff,
				height: this.cropArea.height() * heightDiff,
			});
		}
	}

	// Bind necessary listeners
	addListeners() {
		this.cropArea.on("mousedown.simplecrop", e => {
			e.preventDefault();
			this.mousedown(e);
		});

		$(document).on("mousemove.simplecrop", e => {
			this.mousemove(e);
		});

		$(document).on("mouseup.simplecrop", () => {
			this.mouseup();
		});
	}

	// Remove bound listeners
	removeListeners() {
		this.element.off("load.simplecrop");
		this.cropArea.off("mousedown.simplecrop");
		$(document).off("mousemove.simplecrop");
		$(document).off("mouseup.simplecrop");
	}

	// The mousedown handler on the crop area
	mousedown(e) {
		this.direction = $(e.target).data("dir");

		if (!this.direction) {
			this.direction = $(e.target).parent().data("dir");
		}

		if (!this.direction) {
			this.direction = "*";
		}

		this.anchorX = e.clientX;
		this.anchorY = e.clientY;
		this.mouseX = e.clientX;
		this.mouseY = e.clientY;
	}

	// A mouse move handler for the whole document
	mousemove(e) {
		if (this.direction) {
			this.mouseX = e.clientX;
			this.mouseY = e.clientY;
			this.dragging(e);
		}
	}

	// A mouse up handler for the whole document
	mouseup() {
		this.direction = "";
	}

	// Set the crop area back to the top-middlish
	resetCropArea() {
		let reset;
		let size;
		let paddingPct = 0.05;

		if (this.image.height > this.image.width) {
			size = this.image.width * (1 - paddingPct * 2);
			let padding = this.image.width * paddingPct;
			reset = {
				left: padding,
				top: padding,
				width: size,
				height: size,
			};
		} else {
			size = this.image.height * (1 - paddingPct * 2);
			reset = {
				left: (this.image.width - size) / 2,
				top: this.image.height * paddingPct,
				width: size,
				height: size,
			};
		}

		this.placeCropArea(reset);
	}

	// Place the crop area at a certain position.
	//
	// attrs	(object) - top, left, width, height of crop area
	// action (string) - String action of what's placing it. 'move' or 'resize'.
	//                   We do some cheating for resize.
	placeCropArea(attrs, action) {
		// Keep the position inside of the container
		attrs = $.extend({}, this.cropData, attrs);
		let minX = false;
		let minY = false;

		// Min sizes
		if (attrs.width < this.cropMin.width) {
			attrs.width = this.cropMin.width;
			if (action === "resize") {
				attrs.left = this.cropData.left;
			}
			minX = true;
		}
		if (attrs.height < this.cropMin.height) {
			attrs.height = this.cropMin.height;

			if (action === "resize") {
				attrs.top = this.cropData.top;
			}

			minY = true;
		}

		// Keep in boundaries
		if (attrs.left < 0) {
			attrs.left = 0;
		}
		if (attrs.top < 0) {
			attrs.top = 0;
		}

		if (attrs.left + attrs.width > this.image.width) {
			if (action === "resize" && !minX) {
				attrs.width = this.image.width - attrs.left;
			} else {
				attrs.left = this.image.width - attrs.width;
			}
		}

		if (attrs.top + attrs.height > this.image.height) {
			if (action === "resize" && !minY) {
				attrs.height = this.image.height - attrs.top;
			} else {
				attrs.top = this.image.height - attrs.height;
			}
		}

		// Enforce aspect ratio, pick the smaller of the two
		if (
			(attrs.width / attrs.height).toFixed(2) !==
			this.settings.aspectRatio.toFixed(2)
		) {
			if (attrs.width / this.settings.aspectRatio > attrs.height) {
				attrs.width = attrs.height * this.settings.aspectRatio;
			} else {
				attrs.height = attrs.width / this.settings.aspectRatio;
			}

			if (action === "resize") {
				attrs.left = this.cropData.left;
			}
		}

		this.cropArea.css(attrs);
		$.extend(this.cropData, attrs);
	}

	// Event for when you're dragging the crop area, or resizing it
	dragging() {
		let action = "resize";
		let { direction } = this;
		let ar = this.settings.aspectRatio;
		let cropData = jQuery.extend({}, this.cropData);
		let range = {
			x: this.mouseX - this.anchorX,
			y: this.mouseY - this.anchorY,
		};

		range.X = range.y * ar;
		range.Y = range.x / ar;

		switch (direction) {
			// dragging
			case "e":
				cropData.width += range.x;
				cropData.height = cropData.width / ar;
				cropData.top -= range.Y / 2;
				break;
			case "n":
				cropData.height -= range.y;
				cropData.width = cropData.height * ar;
				cropData.left += range.X / 2;
				cropData.top += range.y;
				break;
			case "w":
				cropData.width -= range.x;
				cropData.height = cropData.width / ar;
				cropData.left += range.x;
				cropData.top += range.Y / 2;
				break;
			case "s":
				cropData.height += range.y;
				cropData.width = cropData.height * ar;
				cropData.left -= Math.round(range.X / 2);
				break;
			case "ne":
				cropData.height -= range.y;
				cropData.width = cropData.height * ar;
				cropData.top += range.y;
				break;
			case "nw":
				cropData.height -= range.y;
				cropData.width = cropData.height * ar;
				cropData.left += range.X;
				cropData.top += range.y;
				break;
			case "sw":
				cropData.width -= range.x;
				cropData.height = cropData.width / ar;
				cropData.left += range.x;
				break;
			case "se":
				cropData.width += range.x;
				cropData.height = cropData.width / ar;
				break;

			// moving
			default:
				action = "move";
				cropData.left += this.mouseX - this.anchorX;
				cropData.top += this.mouseY - this.anchorY;
		}

		let oldCrop = jQuery.extend({}, this.cropData);
		this.placeCropArea(cropData, action);

		let anchorXMult = 1;
		let anchorYMult = 1;

		if (direction.indexOf("n") > -1) {
			anchorYMult = 0;
		}

		if (direction.indexOf("w") > -1) {
			anchorXMult = 0;
		}

		this.anchorX += this.cropData.left - oldCrop.left;
		this.anchorY += this.cropData.top - oldCrop.top;
		this.anchorX += (this.cropData.width - oldCrop.width) * anchorXMult;

		this.anchorY += (this.cropData.height - oldCrop.height) * anchorYMult;
	}

	// Spit out the crop data in a nice format, and have the scale applied to it
	output() {
		if (this.active) {
			let diff;
			let output = {
				height: Math.ceil(this.cropData.height * this.image.scale),
				width: Math.ceil(this.cropData.width * this.image.scale),
				top: Math.max(Math.ceil(this.cropData.top * this.image.scale), 0),
				left: Math.max(Math.ceil(this.cropData.left * this.image.scale), 0),

				bottom: Math.ceil(
					(this.cropData.top + this.cropData.height) * this.image.scale
				),

				right: Math.ceil(
					(this.cropData.left + this.cropData.width) * this.image.scale
				),
			};

			// Clamp the dimensions to the size of the image if anything exceeds the limits
			if (
				output.bottom > this.image.naturalHeight ||
				output.right > this.image.naturalWidth
			) {
				diff = Math.max(
					output.bottom - this.image.naturalHeight,
					output.right - this.image.naturalWidth
				);
				if (diff > 0) {
					output.bottom -= diff;
					output.right -= diff;
					output.height -= diff;
					output.width -= diff;
				}
			}

			if (output.top < 0 || output.left < 0) {
				diff = Math.max(-output.top, -output.left);
				if (diff > 0) {
					output.top += diff;
					output.left += diff;
					output.height += diff;
					output.width += diff;
				}
			}

			return output;
		} else {
			return this.savedOutput;
		}
	}
}

SimpleCrop.initClass();

// Register as jQuery plugin
$.fn.simpleCrop = function(options) {
	this.each(function() {
		let $this = $(this);
		let data = $this.data("simplecrop");

		if (!data) {
			data = new SimpleCrop(this, options);
			$this.data("simplecrop", data);
		}

		if (typeof options === "string" && $.isFunction(data[options])) {
			data[options]();
		}

		return data;
	});
};



// WEBPACK FOOTER //
// ./src/legacy/okphotos/simplecrop.js